import { openBiDirectionalChannel } from '../utils';
import { ON_LANGUAGE_CHANGE } from '../constants';
var onLanguageChange = params => {
  openBiDirectionalChannel(params, {
    type: ON_LANGUAGE_CHANGE
  });
};
export default onLanguageChange;